import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dayInput", "total"]

  connect() {
    this.calculate()
  }

  calculate() {
    const sum = this.dayInputTargets.reduce((acc, el) => acc + (parseFloat(el.value) || 0), 0)
    this.totalTarget.textContent = sum % 1 === 0 ? sum.toString() : sum.toFixed(1)
  }
}
